import styled from 'styled-components';

export const AvatarContainer = styled.div`
  overflow: hidden;
  height: 200px;
  width: 200px;
  aspect-ratio: 1/1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

export const ErrorMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  padding: 0 10px;
  transition: 0.5s;

  &:hover {
    transform: scale(1.1);
  }
`;

export const LoadingAnimation = styled.div`
  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #eee;
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
  position: absolute;
  top: 0;
  left: 0;
`;

export const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
  transition: 0.5s all ease-in-out;
  border-radius: 50%;

  &:hover {
    transform: scale(1.16);
  }
`;
